import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {
  constructor(public http : HttpClient) { }
  baseUrl = environment.baseUrl

  promoList(obj:any,token:any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token
      })
    }
    return this.http.get(this.baseUrl + `/getPromotionalCodeList`,httpOptions);
  }

  userList(obj:any,token:any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token
      })
    }
    return this.http.get(this.baseUrl + `/getPromotionalEligibleUserList?limit=${obj.limit}&offset=${obj.offset}&search=${obj.search}`,httpOptions);
  }

  promoCodeAdd(obj:any,token:any){
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token,
        "Content-Type":"application/json"
      })
    }
    return this.http.post(this.baseUrl + `/sendPromotionalCodeToUsers`,obj, httpOptions);
  }

}
